$(document).ready(function(){
    $('.accordion-button').click(function(){
        $(this).toggleClass('oopen');
        $(this).attr('aria-expanded','false');
        $(this).attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true'
        });
    });

$('#navbar-icons .nav-item').click(function(){
    $(this).find('h2#offcanvas-cart-label').focus()
})

$('.yotpo-icon-btn-big.transparent-color-btn a').attr('aria-label','review here, this link open in new tab');
$(document).ready(function () {
  setTimeout(function () {
$('.yotpo-pager').removeAttr('role');
$('.yotpo-header-element .y-label.yotpo-user-name.yotpo-font-bold.pull-left').attr('role','heading');
$('.label-with-tooltip.pull-left').attr('role','heading');
$('#product-media-slider-thumbs-list').removeAttr('aria-orientation');
}, 3000);
}, 3000);
$('.toggler').click(function(){
  $(this).toggleClass('oopen');
  $(this).attr('aria-expanded', function (i, attr) {
    return attr == 'true' ? 'false' : 'true'
  });
});


 });

 $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('.main-widget.yotpo-display-wrapper').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
     console.log("Customer Email Laoding");
  $('.yotpo-icon-btn-big.transparent-color-btn a').attr('aria-label','review here, this link open in new tab');
    }
  }); 
 $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('#simpAskQuestion').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
     console.log("Customer Email Laoding");
  $('.questionMarkFormat').attr('aria-label','Loader');
    }
  }); 
 $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('iframe#dummy-chat-button-iframe').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
     console.log("Customer Email Laoding");
  $('iframe#dummy-chat-button-iframe').attr('title','Chat with Us');
    }
  }); 

// $(document).ready(function(){
//     // $('.accordion-button').click(function(){
//     //     $(this).toggleClass('oopen');
        
//     //     $(this).attr('aria-expanded', function (i, attr) {
//     //         return attr == 'true' ? 'false' : 'true'
//     //     });
//     // });


//     // reversedetech


//     $(".imgwithtxth .mainimgtxt .leftimgtext").each(function (i) {
//       $(this).detach().appendTo($(".mainimgtxt").eq(i))
//     });

//     $(".compareimgsec .controlcompare .compareleft").each(function (i) {
//       $(this).detach().appendTo($(".controlcompare").eq(i))
//     });

// $('.yotpo-icon-btn-big.transparent-color-btn a').attr('aria-label','review here, this link open in new tab');
// $(document).ready(function () {
//   setTimeout(function () {
// $('.yotpo-pager').removeAttr('role');
// $('.yotpo-header-element .y-label.yotpo-user-name.yotpo-font-bold.pull-left').attr('role','heading');
// $('.label-with-tooltip.pull-left').attr('role','heading');
// $('#product-media-slider-thumbs-list').attr('role','region');
// }, 3000);
// }, 3000);
// $('.toggler').click(function(){
//   $(this).toggleClass('oopen');
//   $(this).attr('aria-expanded', function (i, attr) {
//     return attr == 'true' ? 'false' : 'true'
//   });
// });


//  });

//  $( document ).ready(function() {
//     //wait until the last element (#checkout-step-shipping_method) being rendered
//     var existCondition = setInterval(function() {
//      if ($('.main-widget.yotpo-display-wrapper').length) { 
//       clearInterval(existCondition);
//       runMyFunction2();
//      }
//     }, 200);

//     function runMyFunction2(){
//      console.log("Customer Email Laoding");
//   $('.yotpo-icon-btn-big.transparent-color-btn a').attr('aria-label','review here, this link open in new tab');
//     }
//   }); 
//  $( document ).ready(function() {
//     //wait until the last element (#checkout-step-shipping_method) being rendered
//     var existCondition = setInterval(function() {
//      if ($('#simpAskQuestion').length) { 
//       clearInterval(existCondition);
//       runMyFunction2();
//      }
//     }, 200);

//     function runMyFunction2(){
//      console.log("Customer Email Laoding");
//   $('.questionMarkFormat').attr('aria-label','Loader');
//     }
//   }); 
//  $( document ).ready(function() {
//     //wait until the last element (#checkout-step-shipping_method) being rendered
//     var existCondition = setInterval(function() {
//      if ($('iframe#dummy-chat-button-iframe').length) { 
//       clearInterval(existCondition);
//       runMyFunction2();
//      }
//     }, 200);

//     function runMyFunction2(){
//      console.log("Customer Email Laoding");
//   $('iframe#dummy-chat-button-iframe').attr('title','Chat with Us');
//     }
//   }); 



//   $(document).on("click", "#navbar-icons .nav-item a[role='button'], .d-flex .btn-atc", function () {
//     // 'this' is the element with '.js-no-transition' that was clicked
    
//     setTimeout(function () {
//       // Find the '.tag--active' element within the context of the clicked '.js-no-transition'
//       $(".offcanvas-header .btn-close").attr("tabindex", 0).focus();
      
//     }, 1000);
//   });



  // $("#navbar-icons .nav-item a[role='button'], .d-flex .btn-atc").on("click", function () {
  //   setTimeout(function () {
  //     $(".offcanvas-header .btn-close").attr("tabindex", 0).focus();
  //   }, 1000);
  // });